export const baseURL =
  "https://api.airtable.com/v0/appYFxGlqpW0UKaDL/photology";
export const config = {
  headers: {
    Authorization: "Bearer keyByH3KyRC1apfnn",
  },
};
export const secondaryURL =
  "https://api.airtable.com/v0/appYFxGlqpW0UKaDL/reviews";
